<template>
  <!--  <el-dialog-->
  <!--      :modal="false"-->
  <!--      :visible.sync="focusModal"-->
  <!--      class="pbr-attention-settings"-->
  <!--      title="设置我的关注"-->
  <!--      top="20px"-->
  <!--      width="800px"-->
  <!--      @opened="opened"-->
  <!--  >-->
  <!--    <template #title>-->
  <!--      <div>-->
  <!--        <div class="pbr-title">{{ modalTitle }}</div>-->
  <!--      </div>-->
  <!--    </template>-->
  <!--  </el-dialog>-->

  <Modal
      v-model="focusModal"
      cancel-text=""
      :ok-text="$t('buttons.close')"
      class-name="pbr-personal-focus-modal"
      :title="$t('label.personal.setMyAttention')"
      width="900px"
      @on-ok="close"
      @on-cancel="close">
    <Form ref="focusForm" :label-width="85" :model="formItem" class="pbr-personal-focus-modal-form" label-colon>
      <FormItem :label="$t('label.country')" prop="country">
        <RadioGroup v-model="formItem.country">
          <Radio v-for="(item, index) in countryModels && countryModels.slice(0,6)" :key="index" :label="item.id">
            {{ item.name }}
          </Radio>
          <template v-if="countryModels.length > 6">
            <Select v-model="formItem.country" clearable filterable :placeholder="$t('label.personal.moreCountry')" size="small"
                    style="width:150px">
              <Option v-for="item in countryModels.slice(6,)" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </template>
        </RadioGroup>
      </FormItem>
      <FormItem :label="$t('label.industry')" prop="industry">
        <CheckboxGroup v-model="formItem.industry">
          <Checkbox v-for="(item, index) in industryModels" :key="index" :label="item.id">{{ item.title }}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem :label="$t('label.category')" prop="category">
        <CheckboxGroup v-model="formItem.category">
          <Checkbox v-for="(item, index) in categoryModels" :key="index" :label="item.id">{{ item.title }}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem :label="$t('label.stage')" prop="stage">
        <CheckboxGroup v-model="formItem.stage">
          <Checkbox v-for="(item, index) in stageModels" :key="index" :label="item.id">{{ item.title }}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem :label="$t('label.signDate')" prop="date">
        <CheckboxGroup v-model="formItem.date">
          <Checkbox v-for="(item, index) in dateModels" :key="index" :label="item.id">{{ item.title }}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem :label="$t('label.amount')" prop="amount">
        <CheckboxGroup v-model="formItem.amount">
          <Checkbox v-for="(item, index) in amountModels" :key="index" :label="item.id">{{ item.title }}</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem>
        <div style="display: flex;justify-content: flex-end;align-items: center;padding:0 20px;">
          <el-link :underline="false" icon="el-icon-refresh" type="primary"
                   @click="resetFields">{{$t('buttons.reset')}}</el-link>
          <Divider type="vertical" />
          <el-link :underline="false" icon="el-icon-edit" type="primary"  @click="updateFocus">{{$t('buttons.edit')}}</el-link>
        </div>

      </FormItem>
     </Form>
    <template #footer>
      <div class="pbr-personal-focus-modal-footer">
        <div class="pbr-personal-focus-modal-footer-focus">
          <span style="width: 80px;">{{ $t('label.personal.focused') }}</span>
          <div style="display: flex;flex-direction: column; flex: 0 0 80%;">
            <div v-for="(focus,index) in focusHistory" :key="index" class="pbr-personal-focus-modal-item"
                 @click="focusSelected(focus,index)">
              <div>
                <template v-for="(item,idx) of Object.keys(focus)">
                  <template v-if="item === 'country'">
                    <span v-for="subItem in focus[item]" :key="subItem.id" style="margin: 0 10px 0 0;">{{ subItem.name }}</span>
                  </template>
                  <template v-else-if="item !== 'id'">
                    <template v-if="index ===  selectedListIndex">
                      <el-tag v-for="subItem in focus[item]" :key="subItem.id" :color="tagColor()"
                              :disable-transitions="false" closable
                              effect="light" hit size="mini"
                              style="margin: 0 5px 0 0;" @close="handleFilterTagsClose(subItem,focus,item)">
                        {{ subItem.name || '' }}
                      </el-tag>
                    </template>
                    <template v-else>
                      <span v-for="subItem in focus[item]" :key="subItem.id"
                            style="margin: 0 10px 0 0;">{{ subItem.name }}</span>
                    </template>
                  </template>
                </template>
              </div>
              <span style="width: 50px"><el-link :underline="false" icon="el-icon-close" type="danger"
                                                 @click.stop="deleteFocus(focus)"></el-link></span>
            </div>

          </div>
        </div>
        <Button type="primary" @click="close">{{ $t('buttons.close') }}</Button>
      </div>
    </template>

  </Modal>

</template>

<script>
export default {
  name: 'pbrFocusModal',
  props: {
    title: {
      type: String,
      default: '设置我的关注'
    },
    succeed: {
      type: Function
    }
  },
  data () {
    return {
      from: 'cn',
      modalTitle: this.title,
      focusList: [],
      currentFocus: [],
      focusModal: false,
      focusModalLoading: false,
      countryModels: [],
      regionModels: [],
      enterpriseModels: [],
      industryModels: [],
      categoryModels: [],
      amountModels: [],
      dateModels: [],
      stageModels: [],
      formItem: {
        id: null,
        country: '',
        industry: [],
        company: [],
        stages: [],
        category: [],
        date: [],
        stage: [],
        amount: []
      },
      columns: [
        {
          title: 'name'
        }
      ],
      focusHistory: [],
      selectedListIndex: 9999
    }
  },
  computed: {},
  methods: {
    open (form) {
      this.focusModal = true
      this.resetFields()
      this.fetchFocusHistory()
    },
    opened () {
      if (this.readonly) {

      }
    },
    close () {
      this.focusModal = false
      this.succeed && this.succeed()
    },
    // 判断是否深色模式
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    handleFilterTagsClose (tag, focus, key) {
      let item = focus[key]
      item.splice(item.findIndex(t => t.id === tag.id), 1)
      this.formItem[key] = item
    },
    tagColor () {
      return this.isDark() ? '#0D2E53' : '#fff'
    },
    resetFields () {
      this.$refs.focusForm.resetFields()
      this.formItem.id = null
      this.selectedListIndex = 9999
    },
    fetchFocusHistory () {
      this.$pbrApis.fetchFocusHistory({currentpage: 1, pagesize: 20, userid: 1}).then(res => {
        if (!res) {

        } else if (res.code === 200) {
          this.focusList = res.result
        } else {

        }
        this.generateList()
      })
    },
    generateList () {
      if (this.focusList) {
        let focusHistory = []

        this.focusList.models && this.focusList.models.forEach(item => {
          let p = {
            id: item.id
          }
          for (let i of Object.keys(item)) {
            if (i !== 'id') {
              p[i] = []
              item[i] && item[i].length > 0 && item[i].split(',').forEach(subItem => {
                let temp = this[i + 'Models'].find(t => t.id === subItem)
                p[i].push({id: subItem, name: temp.name || temp.title})
              })
            }
          }
          focusHistory.push(p)
        })
        if (focusHistory.length > 0) {
          let fc = focusHistory[0]
          this.formItem.id = fc.id
          delete fc.id
          for (let i of Object.keys(fc)) {
            if (i === 'country') {
              this.formItem[i] = fc[i].map(t => t.id).join('')
            } else {
              this.formItem[i] = fc[i].map(t => t.id)
            }
          }
          focusHistory[0].id = this.formItem.id
        }
        this.focusHistory = focusHistory
      }
    },
    fetchRegionList () {
      this.$pbrApis
        .fetchRegionList({pid: 0, level: 1, type: 'a'})
        .then(res => {
          if (res && res.success){
            console.log('发布项目获取国家列表接口', res)
            this.countryModels = res.result
            this.fetchProjectGCondition()
          }
        })
    },
    fetchProjectGCondition () {
      this.$pbrApis.fetchProjectGCondition({from: 'cn'}).then(res => {
        if (!res) {

        } else if (res.code === 200) {
          this.regionModels = res.result.regionModels
          this.enterpriseModels = res.result.enterpriseModels
          this.industryModels = res.result.industryModels
          this.categoryModels = res.result.typeModels
          this.amountModels = res.result.amountModels
          this.dateModels = res.result.dateModels
          this.stageModels = res.result.stageModels
        } else {

        }
      })
    },
    fetchGConditions () {
      this.$pbrApis.fetchMyprojectGConditions({from: 'cn'}).then(res => {
        console.log('发布项目下拉条件', res)

        if (!res) {
          this.$message.error({
            content: this.$t('message.error.server'),
            duration: 5
          })
        } else if (res.success) {
          this.companyModels = res.result.companyModels
          this.industryModels = res.result.industryModels
          this.categoryModels = res.result.typeModels
          this.parkModels = res.result.parkModels
          this.stageModels = res.result.stageModels
          this.executeModels = res.result.executeModels
          this.financingModels = res.result.financingModels
        }
      })
    },
    generateParams () {
      let params = {}

      params.id = this.formItem.id
      params.useid = 1
      params.from = this.from
      params.country = this.formItem.country
      params.industry = this.formItem.industry.join(',')
      params.company = this.formItem.company.join(',')
      params.category = this.formItem.category.join(',')
      params.stage = this.formItem.stage.join(',')
      params.date = this.formItem.date.join(',')
      params.amount = this.formItem.amount.join(',')
      return params
    },
    updateFocus () {
      if (this.formItem.country === '') {
        //this.$iMessage.error({content: this.$t('message.error.selectCountry'), duration: 5})
        return
      }
      let params = this.generateParams()

      this.$pbrApis.updateFocus(params).then(res => {
        if (!res) {

        } else if (res.code === 200) {
          this.fetchFocusHistory()
        } else {

        }
      })
    },
    deleteFocus (item) {
      this.$pbrApis.deleteFocus({id: item.id, userid: 1}).then(res => {
        if (!res) {

        } else if (res.code === 200) {
          this.fetchFocusHistory()
          this.resetFields()
        } else {

        }
      })
    },
    focusSelected (focus, index) {
      this.selectedListIndex = index
      let selectedFocus = Object.assign({},focus)
      this.formItem.id = focus.id
      delete selectedFocus.id
      this.$refs.focusForm.resetFields()
      for (let i of Object.keys(selectedFocus)) {
        if (i === 'country') {
          this.formItem[i] = selectedFocus[i].map(t => t.id).join('')
        } else {
          this.formItem[i] = selectedFocus[i].map(t => t.id)
        }
      }
    }
  },
  created () {
    // this.$refs.focusForm.resetFields()
    this.fetchRegionList()
  },
  mounted () {
  }
}
</script>

<style scoped>
/deep/ .ivu-form-item {
  margin-bottom: 0;
}
</style>

<style>
.ivu-message {
  z-index: 3000 !important;
}

.pbr-personal-focus-modal .ivu-modal-header {

}
</style>
